<div class="innerpage-fullwithbanner">
  <h2 class="bighead">{{pageHeading}}</h2>
  <ul class="bread-crumbs">
    <li><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
    <li><a (click)="OnClickLink()">{{prevPage}}<span>|</span></a></li>
    <li>{{pageHeading}}</li>
  </ul>
</div>
<div class="section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="border-div margin0">
      <h2 class="mainhead "><span class="text">Profile</span></h2>
      <div class="leftsideprofile">
        <div class="profilepic">
          <img #profilePic src="{{userInputModel.ProfilePicPath}}">
          <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) (selectedFilePathEmitter)="selectedFilePathEmitter($event)" [uploadType]="fileUploadType" [clearFilescounter]="clearFiles"></file-upload>
          <a *ngIf="imageIdToDelete != null" href="javascript:void(0);" (click)="openModalForDelete(template,'deletemodal',imageIdToDelete,'the profile picture')" class="deletepic" triggers="hover" tooltip="Remove">
            <i class="icofont icofont-close icon"></i>
          </a>
        </div>
      </div>
      <div class="rightsideprofile">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">First Name<span class="red">*</span></label>
              <input class="form-control" #firstNameinput="ngModel" (keydown)="onKeydown($event)" [(ngModel)]="userInputModel.FirstName" required type="text" maxlength="30" autocomplete="off">
              <p class="redtext" *ngIf="!showFNSpecCharVal && (firstNameValid && firstNameinput.invalid && firstNameinput.touched)">First name is required </p>
              <p class="redtext" *ngIf="!showFNSpecCharVal && (!firstNameValid)">First name is required </p>
              <p class="redtext" *ngIf="showFNSpecCharVal">{{specCharValMsg}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Last Name<span class="red">*</span></label>
              <input class="form-control" #lastNameinput="ngModel" [(ngModel)]="userInputModel.LastName" (keydown)="onKeydown($event)" required type="text" maxlength="30" autocomplete="off">
              <p class="redtext" *ngIf="!showLNSpecCharVal && (lastNameValid && lastNameinput.invalid && lastNameinput.touched)">Last name is required </p>
              <p class="redtext" *ngIf="!showLNSpecCharVal && (!lastNameValid)">Last name is required </p>
              <p class="redtext" *ngIf="showLNSpecCharVal">{{specCharValMsg}}</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Email<span class="red">*</span></label>
              <input class="form-control" #emailinput="ngModel" (change)="validateemail()" [(ngModel)]="userInputModel.EmailAddress" (keydown)="onKeydown($event)" required type="text" maxlength="100" autocomplete="off">
              <p class="redtext" *ngIf="(emailValid) && emailinput.invalid && emailinput.touched">Email is required</p>
              <p class="redtext" *ngIf="(!emailValid) && emailvalidation ==''">Email is required</p>
              <p class="redtext" *ngIf="(emailvalidation!='' && userInputModel.EmailAddress!='')">{{emailvalidation}}</p>

            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Password<span class="red">*</span></label>
              <div *ngIf="!showUpdatePassword">
                <input class="form-control" #passwordinput="ngModel" [disabled]="IsEditMode" (change)="validatepassword()" required [(ngModel)]="userInputModel.Password" (keydown)="onKeydown($event)" type="password" maxlength="250" autocomplete="new-password">
                <p class="redtext" *ngIf="(passwordValid && passwordinput.invalid && passwordinput.touched && passwordValidation =='') || (!passwordValid && passwordValidation =='')">Password is required</p>
                <p class="redtext" *ngIf="(passwordValidation!='' && userInputModel.Password!='')">{{passwordValidation}}</p>
              </div>
              <div class="d-flex flex-wrap gap-2" style="gap: 2px;" *ngIf="showUpdatePassword">
                <button class="btn btn-success user-add-update-pwd btn-lg flex-fill" (click)="openModalChangePassword(ChangePassword,'portfolioUpload userchangepasswordmodal')">
                  Update Password
                </button>

                <button class="btn btn-success user-add-update-pwd btn-lg flex-fill" (click)="sendResetPassword();">
                  Send Reset Password Link
                </button>
              </div>
              <!--<div *ngIf="showUpdatePassword">
                <button class="btn btn-success user-add-update-pwd  btn-lg" style="margin-right:5px;" (click)="openModalChangePassword(ChangePassword,'portfolioUpload userchangepasswordmodal')">Update Password</button>
                <button class="btn btn-success user-add-update-pwd  btn-lg" (click)="sendResetPassword();">Send Reset Password Link</button>
              </div>-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Phone<span class="red">*</span></label>
              <input class="form-control" #phoneNumberinput="ngModel" (keydown)="onKeydown($event)" required [(ngModel)]="userInputModel.PhoneNumber" mask='(000) 000-0000' type="text" maxlength="20" autocomplete="off">
              <p class="redtext" *ngIf="(phoneValid) && phoneNumberinput.invalid && phoneNumberinput.touched">Phone number is required</p>
              <p class="redtext" *ngIf="(!phoneValid)">Phone number is required</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Address Line 1</label>
              <input class="form-control" [(ngModel)]="userInputModel.Address1" (keydown)="onKeydown($event)" type="text" maxlength="75" autocomplete="off">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Address Line 2</label>
              <input class="form-control" [(ngModel)]="userInputModel.Address2" (keydown)="onKeydown($event)" type="text" maxlength="75" autocomplete="off">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">State</label>
              <label class="select">
                <select class="form-control" [(ngModel)]="userInputModel.StateId" (change)="bindCity()">
                  <option value="0">--Select--</option>
                  <option *ngFor="let states of statesList" [(ngValue)]="states.Id">{{states.Name}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">City</label>
              <label class="select">
                <select class="form-control " [(ngModel)]="userInputModel.CityId">
                  <option value="0">--Select--</option>
                  <option *ngFor="let cities of citiesList" [(ngValue)]="cities.Id">{{cities.Name}}</option>
                </select>
                <i></i>
              </label>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">ZIP</label>
              <input class="form-control" (keydown)="onKeydown($event)" [(ngModel)]="userInputModel.Zip" type="text" maxlength="5" autocomplete="off">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">Company Name</label>
              <input class="form-control" (keydown)="onKeydown($event)" [(ngModel)]="userInputModel.CompanyName" type="text" maxlength="200" autocomplete="off">
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <div class="form-group">
              <label class="form-label">User Status<span class="red">*</span></label>
              <label class="select">
                <select class="form-control" #Status="ngModel" [disabled]="IsAdd" required [(ngModel)]="userInputModel.UserStatus">
                  <option value="0">--Select--</option>
                  <option *ngFor="let userstatus of lookupList" [(ngValue)]="userstatus.id">{{userstatus.description}}</option>
                </select>
                <i></i>
              </label>
              <p class="redtext" *ngIf="(userStatusValid) && userInputModel.UserStatus ==0 && Status.touched">User Status is required</p>
              <p class="redtext" *ngIf="(!userStatusValid)">User Status is required</p>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="cf margin-top-15 margin-bottom-15">
        <div class="table-gray-hd">
          <div class="table basictable">
            <table class="width100">
              <thead>
                <tr>
                  <th>User Role</th>
                  <th>
                    <label class="custom-checkbox margin-right-20">
                      <input type="checkbox" (change)="onCheckboxSelect(1,$event);" (keydown)="onKeydown($event)" [ngModel]="IsPrincipal" />
                      <i class="form-label"></i>Principal
                    </label>
                  </th>
                  <th>
                    <label class="custom-checkbox margin-right-20">
                      <input type="checkbox" (change)="onCheckboxSelect(2,$event);" [disabled]="IsBroker" [(ngModel)]="userInputModel.Is1031User" />
                      <i class="form-label"></i>1031
                    </label>
                  </th>
                  <th>
                    <label class="custom-checkbox">
                      <input type="checkbox" (change)="onCheckboxSelect(3,$event);" [(ngModel)]="IsBroker" />
                      <i class="form-label"></i>Broker
                    </label>
                  </th>
                </tr>

              </thead>
            </table>
          </div>
          
        </div>
        <!--<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">User Role<span class="red">*</span></label>
            <label class="custom-checkbox margin-right-20">
              <input type="checkbox" (change)="onCheckboxSelect(1,$event);" (keydown)="onKeydown($event)" [ngModel]="IsPrincipal" />
              <i class="form-label"></i>Principal
            </label>
            <label class="custom-checkbox margin-right-20">
              <input type="checkbox" (change)="onCheckboxSelect(2,$event);" [disabled]="IsBroker" [(ngModel)]="userInputModel.Is1031User" />
              <i class="form-label"></i>1031
            </label>
            <label class="custom-checkbox">
              <input type="checkbox" (change)="onCheckboxSelect(3,$event);" [(ngModel)]="IsBroker" />
              <i class="form-label"></i>Broker
            </label>
          </div>
        </div>-->
      </div>
      <div class="text-right margin-top-20">
        <button type="button" class="btn btn-default btn-lg" (click)="clearFeilds();">Cancel</button>
        <button class="btn btn-success  btn-lg" (click)="saveUser();">Save</button>
      </div>
    </div>

    <div class="border-div margin-top-20 cf" *ngIf="IsSeller">
      <div class="margin-top-10">
        <div class="clearfix">
          <h2 class="mainhead margin-bottom-15"><span class="text">Tickers</span></h2>
          <div class="rightside text-right margin-bottom-15 clearfix" *ngIf="IsSeller">
            <a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" tooltip="Add Tickers" (click)="openAddTicker(AddTicker,'panlestyle')"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="table-responsive">
            <table class="table basictable">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Symbol</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of tickers;let i = index">
                  <td>
                    <p>{{item.Name}}</p>
                  </td>
                  <td>
                    <p>{{item.Symbol}}</p>
                  </td>
                  <td class="whitespacenowrap">
                    <a class="remove" *ngIf="!item.IsDefault" tooltip="Remove" href="javascript:void(0);" (click)="openModalForDeleteTicker(RemoveTicker,'deletemodal',item.Id, i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="tickers?.length == 0 ">
                  <td colspan="3" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Tickers Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>
<!--<ng2-toasty [position]="'top-right'"></ng2-toasty>-->
<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Profile Picture</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to delete {{deleteTask}}?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="onRemoveImage(imageIdToDelete);modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>

<ng-template #AddTicker>
  <app-shared-ticker-add [userId]="userInputModel.Id" (closeModal)="closeAddTickerModal($event)" [modalRef]="modalRefAddTicker"></app-shared-ticker-add>
</ng-template>


<ng-template #RemoveTicker>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Remove Ticker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRemoveTicker.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">Are you sure to remove this ticker for the seller ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefRemoveTicker.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="removeTicker();modalRefRemoveTicker.hide();">Remove</button>
    </div>
  </div>
</ng-template>

<ng-template #GrandOrRevokeProspects>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Grant or Revoke Prospects Access </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRemoveTicker.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">{{prospectText}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefRemoveTicker.hide()">Cancel</button>
      <button class="btn btn-lg btn-primary" (click)="ChangeSellerProspectStatus();modalRefRemoveTicker.hide();">Yes</button>
    </div>
  </div>
</ng-template>
<ng-template #ChangePassword>
  <div class="offredetailspage section-margin">
    <div class="container">
      <div class="row">
        <button type="button" class="close pull-right file-pop-up-close margin-right-10" aria-label="Close" (click)="ClearModel();modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 update-password-maindiv">
          <h3 class="file-bluelabel margin-bottom-15">Update Password</h3>
          <br />
          <form  autocomplete="off">
            <div class="row">
              <div class="col-md-12">
                <label class="form-label">New Password</label>
                <div class="form-group">
                  <input type="password" [ngModelOptions]="{standalone: true}" class="form-control" name="" (keydown)="focusToConfirmPassword($event,'confirmInput')" #passwordinput="ngModel" (change)="validatechangepassword()" [(ngModel)]="newUserPassword" required maxlength="250">
                  <p class="redtext" *ngIf="(passwordValid && passwordinput.invalid && passwordinput.touched && passwordValidation =='') || (!passwordValid && passwordValidation =='')">Password is required</p>
                  <p class="redtext" *ngIf="(passwordValidation!='' && newUserPassword!='')">{{passwordValidation}}</p>
                </div>
              </div>
              <div class="col-md-12">
                <label class="form-label">Confirm Password</label>
                <div class="form-group">
                  <input type="password" [ngModelOptions]="{standalone: true}" (keydown)="handleKeydown($event)" class="form-control" id="confirmInput" name="" #confirmpasswordinput="ngModel" (change)="checkConfirmPasswordValidity($event)" [(ngModel)]="confirmPassword" required maxlength="250">
                  <p class="redtext" *ngIf="(confirmPasswordValidation!='')">{{confirmPasswordValidation}}</p>
                </div>
              </div>
              <div class="col-md-12 padding30">
                <div class="text-right">
                  <button class="btn btn-lg btn-default" id="closeModal" (click)="ClearModel();modalRef.hide()" [class.disabled]="isDisabled">Cancel</button>
                  <button class="btn btn-lg btn-success" (click)="changePasswordonAdminClick();" [class.disabled]="isDisabled">Update</button>
                </div>
              </div>
            </div>
            </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>
